import React from 'react';
import { IContentContainer } from './interfaces';
import { Box, CustomTheme, useMediaQuery, useTheme } from '@mui/material';

export const ContentContainer: React.FC<IContentContainer> = ({
  children,
}): JSX.Element => {
  // TODO: did now fix offset with constant, but this needs to be a prop
  // called 'offset'. The offset should be dynamic set by the parent based on
  // the actual width of the sidebar.
  // const theme = useTheme();

  const theme = useTheme<CustomTheme>();
  const isMobile = useMediaQuery('(max-width: 1000px)');

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        ml: isMobile ? '15px' : `calc(${theme.portal.sidebar.width} + 15px)`,
        mt: '15px',
        mr: '15px',
        mb: '15px',
      }}
    >
      {children}
    </Box>
  );
};
